import { gql } from '@/__generated__';

const UPDATE_DEVICE_OPERATIONAL_STATE = gql(`#graphql
  mutation DeviceConfiguration_UpdateDeviceOperationalState($deviceId: ID!, $operationalState: DeviceOperationalState!) {
    updateDevice(deviceId: $deviceId, input: { operationalState: $operationalState }) {
      id
      profile {
        id
        name
        alias
        originalName
        operationalState
        type: type2
        irrigation {
          id
          name
        }
        organization {
          id
          name
        }
        location {
          latitude
          longitude
        }
      }
    }
  }
`);

export default UPDATE_DEVICE_OPERATIONAL_STATE;
